import {ChangeDetectionStrategy, Component, computed, inject, Signal} from "@angular/core";
import {Page} from "../../navigation/page";
import {ButtonComponent} from "../../buttons/button/button.component";
import {ButtonProminence} from "../../buttons/button/button";
import {OrderingContextModel} from '../../ordering-context/ordering-context.model';
import {TranslateModule} from '@ngx-translate/core';
import {ModalPageLayoutComponent} from '../../page-layout/modal-page-layout/modal-page-layout.component';
import {LegalPanelComponent} from '../../legal/legal-panel/legal-panel.component';
import {PageFooterControlDirective} from '../../page-layout/page-footer-control.directive';
import {ConfigurationModel} from '../../configuration/configuration.model';
import {IconComponent} from '../../ui-elements/icon/icon.component';

@Component({
    selector: "woa-rsa-verification-page",
    templateUrl: "./rsa-verification-page.component.html",
    styleUrl: "./rsa-verification-page.component.scss",
    providers: [{provide: Page, useExisting: RsaVerificationPageComponent}],
    imports: [
        ButtonComponent,
        LegalPanelComponent,
        ModalPageLayoutComponent,
        PageFooterControlDirective,
        TranslateModule,
        IconComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RsaVerificationPageComponent extends Page {
    public orderingContextModel: OrderingContextModel = inject(OrderingContextModel);
    public configurationModel: ConfigurationModel = inject(ConfigurationModel);

    ButtonProminence = ButtonProminence;

    public readonly title: Signal<string> = computed<string>(() =>
        this.configurationModel.isConsumerActor() ? "woa.heading.rsa-verification.title.consumer" : "woa.heading.rsa-verification.title.waiter");

    public readonly cancelButtonLabel: Signal<string> = computed<string>(() =>
        this.configurationModel.isConsumerActor() ? "woa.button.rsa-verification.under" : "woa.button.common.cancel");

    public readonly proceedButtonLabel: Signal<string> = computed<string>(() =>
        this.configurationModel.isConsumerActor() ? "woa.button.rsa-verification.over" : "woa.button.common.proceed");
}
